import React, { memo, useCallback } from "react";
import { IonItem, IonAvatar, IonLabel, IonBadge } from "@ionic/react";

const FALLBACK_AVATAR = "../assets/profilePic.png";

const AVATAR_IMG_STYLE: React.CSSProperties = {
  width: "100%",
  height: "100%",
  objectFit: "cover",
};

const TITLE_STYLE: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: 8,
};

const JOB_BADGE_STYLE: React.CSSProperties = {
  fontSize: "0.65rem",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

interface ChatListItemProps {
  msg: any;
  isScheduler: boolean;
  fallbackAvatar?: string;
  onSelect: (msg: any) => void;
}

const handleImgError = (e: React.SyntheticEvent<HTMLImageElement>) => {
  const el = e.currentTarget;
  if (el.src.includes(FALLBACK_AVATAR)) return;
  el.src = FALLBACK_AVATAR;
};

const ChatListItemImpl: React.FC<ChatListItemProps> = ({
  msg,
  isScheduler,
  fallbackAvatar = FALLBACK_AVATAR,
  onSelect,
}) => {
  const unread = msg?.IsRead === false;
  const kind = msg?._kind;
  const avatarUrl = msg?._avatarUrl || fallbackAvatar;
  const displayDate = msg?._displayDate || "";

  const handleClick = useCallback(() => {
    onSelect(msg);
  }, [onSelect, msg]);

  const avatarClass = unread
    ? isScheduler
      ? "avatarNewMsgSched"
      : "avatarNewMsgWerker"
    : "";

  return (
    <IonItem onClick={handleClick}>
      <IonAvatar className={avatarClass} slot="start">
        <img
          src={avatarUrl}
          alt=""
          width={40}
          height={40}
          loading="lazy"
          decoding="async"
          referrerPolicy="no-referrer"
          onError={handleImgError}
          style={AVATAR_IMG_STYLE}
        />
      </IonAvatar>

      <IonLabel className="labelo">
        <h2 style={TITLE_STYLE}>
          {unread ? <b>{msg.MessageTitle}</b> : msg.MessageTitle}
          {kind === "JOB" && (
            <IonBadge color={unread ? "danger" : "medium"} style={JOB_BADGE_STYLE}>
              JOB
            </IonBadge>
          )}
        </h2>
        <p>{msg._displayPreview}</p>
      </IonLabel>

      <IonLabel slot="end">
        {!!displayDate && <p>{displayDate}</p>}
        <br />
      </IonLabel>

      <br />
    </IonItem>
  );
};

export const ChatListItem = memo(ChatListItemImpl);
export default ChatListItem;
